import proxybase from './proxybase';

class TestService {
  whatsappTemplateTest(body) {
    return proxybase.post('/test/whatsapp-template-test', body);
  }
}

const TestServiceInstance = new TestService();
export default TestServiceInstance;
